
$(document).ready(function(){
    $('.review-slider').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: $(".prev2"),
        nextArrow: $(".next2"),
        responsive: [
            {
            breakpoint: 1026,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
            },
            {
            breakpoint: 770,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
            },
            {
            breakpoint: 600,
            settings: {
                slidesToShow: 1.20,
                slidesToScroll: 1,
                dots: true
            }
            },
            {
            breakpoint: 480,
            settings: {
                slidesToShow: 1.20,
                slidesToScroll: 1,
                dots: true
            }
            }
        ]
    });
});